import styled from '@mui/material/styles/styled';
import {OutboundLink} from 'react-ga';

const Link = styled(OutboundLink)();

export default Link;